import { useSyncExternalStore } from 'react';
import type { DrivingDisabledWarningReason } from '../../robot/driving-disabled-warning';

type DrivingDisabledWarningListener = () => void;

interface DrivingDisabledWarningState {
  nonce: number;
  open: boolean;
  reason: DrivingDisabledWarningReason | null;
}

let drivingDisabledWarningState: DrivingDisabledWarningState = {
  nonce: 0,
  open: false,
  reason: null,
};

const listeners = new Set<DrivingDisabledWarningListener>();

const notifyListeners = () => {
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: DrivingDisabledWarningListener) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => drivingDisabledWarningState;

export const showDrivingDisabledWarning = (reason: DrivingDisabledWarningReason) => {
  drivingDisabledWarningState = {
    nonce: drivingDisabledWarningState.nonce + 1,
    open: false,
    reason,
  };
  notifyListeners();

  queueMicrotask(() => {
    drivingDisabledWarningState = {
      ...drivingDisabledWarningState,
      open: true,
    };
    notifyListeners();
  });
};

export const closeDrivingDisabledWarning = () => {
  if (!drivingDisabledWarningState.open) {
    return;
  }

  drivingDisabledWarningState = {
    ...drivingDisabledWarningState,
    open: false,
  };
  notifyListeners();
};

export const useDrivingDisabledWarningState = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
